module.exports = __webpack_public_path__ + "4f856e5a98b8d54c008510c3878e7dbb.png";